import { observer } from 'owa-mobx-react';

import { Icon } from '@fluentui/react/lib/Icon';
import { Link } from '@fluentui/react/lib/Link';
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';
import React from 'react';
import { getDensityModeCssClass } from 'owa-fabric-theme';
import { isSingleLineListView } from 'owa-mail-layout';
import type { UserSettingsStyleSelector } from '../../utils/getStyleSelectorAsPerUserSettings';

import {
    thirdRowTextWithWarning,
    thirdRowTextSize,
    actionHeaderThirdRow,
    spinner,
    full,
    SLVItemViewSenderImageOn,
    SLVItemViewSenderImageOff,
    SLVConversationViewSenderImageOn,
    SLVConversationViewSenderImageOff,
    threeColItemViewSenderImageOn,
    threeColItemViewSenderImageOff,
    threeColConversationViewSenderImageOn,
    threeColConversationViewSenderImageOff,
    inlineThirdRowContainer,
    thirdRowIcon,
    leftEntitySingleLine,
} from './MailListActionHeaderRow.scss';

import classnames from 'owa-classnames';

export interface MailListActionHeaderRowProps {
    containerCssClass?: string;
    text: string;
    onClick?: (evt?: React.MouseEvent<unknown>) => void;
    showBackArrow?: boolean;
    showLoadingSpinner?: boolean;
    alternativeIcon?: string;
    mailListHeaderStylesAsPerUserSettings?: UserSettingsStyleSelector;
    isItemView: boolean;
}

const defaultExport: React.FunctionComponent<MailListActionHeaderRowProps> = observer(
    function MailListActionHeaderRow(props: MailListActionHeaderRowProps) {
        const { alternativeIcon, mailListHeaderStylesAsPerUserSettings, onClick } = props;
        const densityModeString = getDensityModeCssClass(full, undefined, undefined);

        const textStyle = classnames(thirdRowTextWithWarning, thirdRowTextSize, densityModeString);

        const isSingleLineView = isSingleLineListView();
        const renderLink = () => {
            return (
                <Link onClick={onClick} className={actionHeaderThirdRow} title={props.text}>
                    <span className={textStyle}>{props.text}</span>
                    {props.showLoadingSpinner && (
                        <Spinner className={spinner} size={SpinnerSize.small} />
                    )}
                </Link>
            );
        };
        const renderPlainText = () => {
            return (
                <span className={textStyle} title={props.text}>
                    {props.text}
                </span>
            );
        };
        const hasLeftEntity = isSingleLineView && !props.isItemView;
        const classNameForUserSettings =
            mailListHeaderStylesAsPerUserSettings &&
            (
                {
                    SLVItemViewSenderImageOn,
                    SLVItemViewSenderImageOff,
                    SLVConversationViewSenderImageOn,
                    SLVConversationViewSenderImageOff,
                    threeColItemViewSenderImageOn,
                    threeColItemViewSenderImageOff,
                    threeColConversationViewSenderImageOn,
                    threeColConversationViewSenderImageOff,
                } as const
            )[mailListHeaderStylesAsPerUserSettings];
        return (
            <div
                className={classnames(
                    densityModeString,
                    inlineThirdRowContainer,
                    classNameForUserSettings
                )}
            >
                {alternativeIcon && (
                    <Icon
                        iconName={alternativeIcon}
                        className={classnames(
                            classNameForUserSettings,
                            thirdRowIcon,
                            'flipForRtl',
                            hasLeftEntity && leftEntitySingleLine,
                            densityModeString
                        )}
                    />
                )}
                {props.onClick ? renderLink() : renderPlainText()}
            </div>
        );
    },
    'MailListActionHeaderRow'
);
export default defaultExport;
